'use client';

import { clsx } from 'clsx';
import MoonLoader from 'react-spinners/MoonLoader';
import { twMerge } from 'tailwind-merge';

import type { ComponentProps } from 'react';

type LoaderProps = {
  className?: HTMLDivElement['className'];
} & ComponentProps<typeof MoonLoader>;

const Loader = ({
  className,
  loading = true,
  color = '#FA0E6A',
  size = 80,
}: LoaderProps) => (
  <div
    className={twMerge(
      clsx(['container flex flex-col items-center justify-center', className])
    )}
  >
    <MoonLoader
      loading={loading}
      color={color}
      size={size}
    />
  </div>
);

export { Loader };
